import { createRoute } from "@tanstack/react-router";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Laura Martin",
    title: "Metal Worker",
  },
  {
    name: "Quinton Pepiot",
    title: "Metal Worker",
    image: "/assets/headshots/quinton-pepiot.png",
  },
  {
    name: "Landrie Patterson",
    title: "Metal Worker",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fpm/operation",
  component: () => <TeamRosterPage team="Metal Working Team" members={members} />,
});
